<script setup lang="ts">
import { computed, ref } from "vue";

const functionName = ref("greet");
const parameterName = ref("name");
const mode = ref<"hello" | "marks">("hello");
const argumentValue = ref("Ali");
const output = ref("");

const functionCode = computed(() => {
  const logicLine = mode.value === "hello"
    ? `    print("Hello", ${parameterName.value || "name"})`
    : `    print("Marks:", ${parameterName.value || "value"})`;

  return `def ${functionName.value || "my_function"}(${parameterName.value || "value"}):\n${logicLine}\n\n${functionName.value || "my_function"}(${JSON.stringify(argumentValue.value)})`;
});

function runFunction() {
  output.value = mode.value === "hello"
    ? `Hello ${argumentValue.value || ""}`.trim()
    : `Marks: ${argumentValue.value || ""}`.trim();
}
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Apna function banao</h2>
      <p class="text-sm text-slate-600">Naam do, value do, aur dekho function kya karta hai.</p>
    </div>

    <div class="mt-4 grid gap-3">
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">Function ka naam</span>
        <input v-model="functionName" type="text" class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
      </label>
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">Andar aane wali value ka naam</span>
        <input v-model="parameterName" type="text" class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
      </label>
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">Function kya kare?</span>
        <select v-model="mode" class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
          <option value="hello">Hello greet karo</option>
          <option value="marks">Marks show karo</option>
        </select>
      </label>
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">Is value ke sath chalao</span>
        <input v-model="argumentValue" type="text" class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
      </label>
    </div>

    <pre class="mt-4 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>{{ functionCode }}</code></pre>

    <button type="button" class="mt-4 rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white" @click="runFunction">
      Run Function
    </button>

    <div v-if="output" class="mt-4 rounded-2xl bg-emerald-50 p-4 ring-1 ring-emerald-200">
      <p class="text-xs font-semibold uppercase tracking-wide text-emerald-700">Bahar kya aya</p>
      <p class="mt-2 text-sm font-medium text-emerald-900">{{ output }}</p>
    </div>
  </section>
</template>
